import { fetchBranding } from './api/branding-client-api';
import type { BrandingClientSetResponse } from './types';

export async function getBrandingByName(
  name: string
): Promise<BrandingClientSetResponse> {
  return fetchBranding({
    urlPrefix: name,
    allowDisabled: true,
  });
}

export async function getBrandingByToken(
  token: string
): Promise<BrandingClientSetResponse> {
  return fetchBranding({ customerToken: token });
}
